import { ArrowLeft, Ban, FileQuestion } from "lucide-react";
import { Link } from "react-router-dom";
import { Logo } from "@/components/common/logo";
import { Button } from "@/components/ui/button";

function ErrorPage({
  icon,
  code,
  title,
  description,
}: {
  icon: React.ReactNode;
  code: string;
  title: string;
  description: string;
}) {
  return (
    <main className="grid min-h-screen place-items-center bg-slate-50 p-6">
      <div className="max-w-lg text-center">
        <Logo className="mb-12 justify-center" />
        <div className="mx-auto grid size-16 place-items-center rounded-2xl bg-indigo-50 text-indigo-600">
          {icon}
        </div>
        <p className="mt-6 text-sm font-bold tracking-widest text-indigo-600">{code}</p>
        <h1 className="mt-2 text-4xl font-bold tracking-tight text-slate-950">{title}</h1>
        <p className="mt-4 leading-7 text-slate-600">{description}</p>
        <Button asChild className="mt-7">
          <Link to="/app">
            <ArrowLeft className="size-4" /> Back to workspace
          </Link>
        </Button>
      </div>
    </main>
  );
}

export function UnauthorizedPage() {
  return (
    <ErrorPage
      icon={<Ban className="size-7" />}
      code="403"
      title="You don’t have access"
      description="This page may be restricted or you may no longer be a member of its group."
    />
  );
}

export function NotFoundPage() {
  return (
    <ErrorPage
      icon={<FileQuestion className="size-7" />}
      code="404"
      title="This page got away"
      description="The link may be outdated, or the page may have been moved or deleted."
    />
  );
}
